import { render } from "./ShortcutDialogSelectedTests.vue?vue&type=template&id=f4d295cc&scoped=true"
import script from "./ShortcutDialogSelectedTests.vue?vue&type=script&lang=js"
export * from "./ShortcutDialogSelectedTests.vue?vue&type=script&lang=js"

import "./ShortcutDialogSelectedTests.vue?vue&type=style&index=0&id=f4d295cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d295cc"]])

export default __exports__